const modal = ()=>{
	if(document.querySelector(".modal-field"))return;
	const modalTargetSelector = `[data-js-modal]`;
	const modalTypeAttr = `data-js-modal-type`;
	const modalTypeSelector = `[${modalTypeAttr}]`;
	const modalCloseAttr = `data-js-modal-close`;
	const modalCloseSelector = `[${modalCloseAttr}]`;
	const modalInsertTargetAttr = `data-js-modal-content`;
	const srcAttr = `data-src`;

	const modalField = createModalField();
	document.body.appendChild(modalField);
	const modalInsertTarget = modalField.querySelector(`[${modalInsertTargetAttr}]`);


	const iframeModalField = createIFrameField();
	const imgModalField = createImageField();
	document.body.addEventListener("click", (ev) => {
		if (ev.target.closest(modalTargetSelector)) {
			// modalTypeに応じたモーダル処理を行う
			const target =  ev.target.closest(modalTypeSelector);
			const modalType =target.getAttribute(modalTypeAttr);
			// Typeがない場合は何もしない
			if (!modalType) {
				return
			}
			let removeTarget = modalInsertTarget.children[0];
			if(removeTarget)modalInsertTarget.removeChild(removeTarget);
			modalField.classList.remove(`js-disp-hide`);
			let insertTarget;
			if(modalType === "iframe"){
				insertTarget= iframeModalField;
			}
			if(modalType === "img"){
				insertTarget= imgModalField;
			}
			insertTarget.src = target.getAttribute(srcAttr);
			if(insertTarget)modalInsertTarget.appendChild(insertTarget);
			return;
		}
		// SVGの場合の処理を書く

		if (ev.target.closest(modalCloseSelector)) {
			// モーダル閉じる
			modalField.classList.add(`js-disp-hide`);
		}
	});




	function createIFrameField(src="") {
		const iframe = document.createElement("iframe");
		return iframe
	}

	function createImageField(src ="" , alt="") {
		const img = document.createElement("img")
		return img
	}

	function createModalField() {
		const modalWrap = document.createElement("div");
		modalWrap.innerHTML = `
		<div class="modal-field js-disp-hide">
			<div class="modal-field__bk" ${modalCloseAttr}>

			</div>
			<div class="modal-field__inner">
				<div class="modal-field__content" ${modalInsertTargetAttr}>

				</div>
				<div class="modal-field__close" ${modalCloseAttr}>×</div>
			</div>
		</div>
		`;
		return modalWrap.children[0];
	}
};
modal();
